import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';
import { IconX } from '@tabler/icons-react';

import { IconButton, Typography } from '@zendesk/forethought-elements';

interface PanelReadOnlyBannerProps {
  onClose: () => void;
}

export const PanelReadOnlyBanner = ({ onClose }: PanelReadOnlyBannerProps) => {
  const { t } = useTranslation('workflow-builder-edit');
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: palette.colors.yellow[100],
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'space-between',
        mb: 2,
        p: 1.5,
      }}
    >
      <Typography color={palette.colors.grey[800]} variant='font14'>
        {t('customizationPanel.panelReadOnlyBanner.message')}
      </Typography>
      <IconButton
        aria-label={t('customizationPanel.panelReadOnlyBanner.closeAriaLabel')}
        data-readonly-dismiss
        onClick={onClose}
        variant='ghost'
      >
        <IconX color={palette.colors.grey[800]} size={20} />
      </IconButton>
    </Box>
  );
};
